import { Component,OnInit, ElementRef, Renderer2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as confetti from 'canvas-confetti';
import { ModalAniversarioService } from '../../components/modal-aniversario/modal-anniversario.service';

interface LogoProgramado {
  nombre: string;
  archivo: string;
  activo: boolean;
  fechaInicio: string;
  fechaFin: string;
}

const RUTA_LOGOS = 'assets/images/logos/';
const LOGO_DEFAULT = RUTA_LOGOS + 'logo_myt.png';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  public clicked = false;
  public logoActual = LOGO_DEFAULT;

  constructor(private translate: TranslateService, private renderer2: Renderer2,
    private elementRef: ElementRef,
    private modalService: ModalAniversarioService,
    private http: HttpClient) {
    translate.setDefaultLang('es');
  }

  ngOnInit() {
    // this.fiesta();
    this.cargarLogo();
    setTimeout(()=>{
      this.modalService.mostrarModal();
    }, 1000);
  }

  // Si el archivo del logo programado no existe, regresa al logo por defecto
  logoNoEncontrado() {
    this.logoActual = LOGO_DEFAULT;
  }

  private cargarLogo() {
    this.http.get<LogoProgramado[]>('assets/data/logos.json')
      .subscribe((logos) => {
        // Si hay varios vigentes a la vez, gana el primero de la lista
        const vigente = (logos || []).find((logo) => this.logoEsVigente(logo));
        this.logoActual = vigente ? RUTA_LOGOS + vigente.archivo : LOGO_DEFAULT;
      }, () => {
        this.logoActual = LOGO_DEFAULT;
      });
  }

  private logoEsVigente(logo: LogoProgramado): boolean {
    if (!logo || !logo.activo || !logo.archivo) {
      return false;
    }

    const inicio = this.parsearFecha(logo.fechaInicio, false);
    const fin = this.parsearFecha(logo.fechaFin, true);
    if (!inicio || !fin) {
      return false;
    }

    const ahora = new Date().getTime();
    return ahora >= inicio.getTime() && ahora <= fin.getTime();
  }

  // Formato YYYY-MM-DD; el inicio cuenta desde las 00:00 y el fin hasta las 23:59:59
  private parsearFecha(fecha: string, finDelDia: boolean): Date | null {
    if (!fecha) {
      return null;
    }

    const partes = fecha.split('-');
    if (partes.length !== 3) {
      return null;
    }

    const anio = Number(partes[0]);
    const mes = Number(partes[1]) - 1;
    const dia = Number(partes[2]);

    const resultado = finDelDia
      ? new Date(anio, mes, dia, 23, 59, 59, 999)
      : new Date(anio, mes, dia, 0, 0, 0, 0);
    if (resultado.getFullYear() !== anio || resultado.getMonth() !== mes || resultado.getDate() !== dia) {
      return null;
    }

    return resultado;
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

  ejemploConfeti() {
    const canvas = this.renderer2.selectRootElement('#miCanvas');
    const myConfetti = confetti.create(canvas, {
      resize: true,
      particleCount: 200,
      spread: 70,
      origin: { y: -1 }
    });
    myConfetti();
  } 
  
  fiesta() {
    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }
    const canvas = this.renderer2.selectRootElement('#miCanvas');
    const myConfetti = confetti.create(canvas, {
      resize: true,
      angle: randomInRange(55, 125),
      spread: randomInRange(50, 70),
      particleCount: randomInRange(50, 100),
      origin: { x: 0, y: 0.9 }
    });

    let contador = 0;
    const intervalo = setInterval(() => {
      myConfetti();
      // contador++;
      // if (contador === 50) {
      //   clearInterval(intervalo);
      // }
    }, 2500);
  }
}
